// extracted by mini-css-extract-plugin
export default {"listItem":"DefinitionsList-module__listItem--eGK2P"};